import FxstPayWalletPageContainer from "../../Component/WalletTransfer/FxstPayWallet/FxstPayWallet"

const FxstPayWalletPage = () => {
  return (
    <div className='page-body'>
      <FxstPayWalletPageContainer />
    </div>
  )
}

export default FxstPayWalletPage